import { Link } from "react-router-dom";
import type { Movie } from "@/utils/movies";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-secondary-100">
        <img
          src={movie.poster}
          alt={`${movie.title} 影视封面`}
          title={`${movie.title} - 影视作品封面`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-medium bg-primary-600/90 text-background-50">
          {movie.type === "movie" ? "电影" : "电视剧"}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-[11px] font-bold bg-accent-500 text-white font-label">
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 font-label">
          {movie.year} · {movie.region}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {movie.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-800"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}